'use client';

import React, { useMemo } from 'react';

import { Divider, Justifiable, Text, TextLevels, TypographyBold, View } from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';
import { YounitedIcon } from '@components/younited';

import { isYounited } from '@helpers/funding';

import { PricesDetails } from '@product-detail/helpers';

type TicketFundingProps = {
    prices: PricesDetails;
};

export function TicketFunding({ prices }: TicketFundingProps) {
    const { productPrices, funding } = prices;

    const isYounitedFunding = useMemo(() => funding && isYounited(funding?.type), [funding?.type]);

    if (!funding || funding.installmentCount <= 0) return null;

    return (
        <>
            <Divider />
            <View flexable justify={Justifiable.SPACE_BETWEEN}>
                <div>
                    {isYounitedFunding && <YounitedIcon />}
                    <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} level={TextLevels.TWO} marginless>
                        {funding.label} x{funding.installmentCount} mois {funding.interestAmount > 0 ? 'avec' : 'sans'}
                        &nbsp;frais
                    </Text>
                    {isYounitedFunding && (
                        <Text level={TextLevels.THREE} marginless>
                            Prélevés par Younited
                        </Text>
                    )}
                </div>
                {productPrices.fundingMonthlyAmount > 0 && (
                    <InlinePrice level={TextLevels.TWO} amount={productPrices.fundingMonthlyAmount} period='mois' />
                )}
            </View>
        </>
    );
}
